import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var PrivilegeService = /** @class */ (function () {
    function PrivilegeService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    // Logged in PersonId is used for this service, not passing personid param expicilty
    PrivilegeService.prototype.findByRelationship = function (relationship) {
        var api = _GlobalNS.api.user.relationshipPrivilegeByPerson;
        var params = new HttpParams().set('RelationshipId', relationship[0].Id.toString());
        return this._http.get("" + api, { params: params }).pipe(catchError(function (err) {
            return throwError(err);
        }));
    };
    PrivilegeService.prototype.findByRelationshipTypeID = function (relationshipTypeId) {
        var api = _GlobalNS.api.partner.partnerTypePrivileges;
        var params = new HttpParams().set('RelationshipTypeId', relationshipTypeId.toString());
        return this._http.get("" + api, { params: params }).pipe(catchError(function (err) {
            return throwError(err);
        }));
    };
    /*
    return privilges based on Enabled or Not
    */
    PrivilegeService.prototype.findByStatus = function (privileges, enabled) {
        var filteredPrivileges = [];
        if (privileges !== null && privileges !== undefined && privileges.length > 0) {
            filteredPrivileges = privileges.filter(function (privilegeFilter) { return privilegeFilter.Enabled === enabled; });
        }
        return filteredPrivileges;
    };
    /*
    return privilgeGroups based on Enabled or Not
    */
    PrivilegeService.prototype.findGroupByStatus = function (privilegeGroups, enabled) {
        var filteredPrivilegeGroups = [];
        if (privilegeGroups !== null && privilegeGroups !== undefined && privilegeGroups.length > 0) {
            filteredPrivilegeGroups = privilegeGroups.filter(function (privilegeGroupFilter) { return privilegeGroupFilter.Enabled === enabled; });
        }
        return filteredPrivilegeGroups;
    };
    /*
     Remove unwanted elements privilegeGroup for Save / Update user
   */
    PrivilegeService.prototype.privilegeGroupData = function (privilegeGroups) {
        var _this = this;
        var privilegeGroupData = [];
        if (privilegeGroups !== undefined && privilegeGroups.length) {
            privilegeGroups.filter(function (privileGroupFilter) {
                return (privileGroupFilter.Enabled === undefined || privileGroupFilter.Enabled);
            }).map(function (privileGroup) {
                privilegeGroupData.push({
                    CompanyGroupId: privileGroup.CompanyGroupId,
                    GroupName: privileGroup.GroupName,
                    Enabled: privileGroup.Enabled,
                    Privileges: _this.privilegeData(privileGroup.Privileges)
                });
            });
        }
        return privilegeGroupData;
    };
    /*
     remove unwanted elements privilege for Save / Update user
    */
    PrivilegeService.prototype.privilegeData = function (privileges) {
        var formattedPrivileges = [];
        if (privileges !== undefined && privileges.length) {
            privileges.filter(function (privilegeFilter) { return (privilegeFilter.Enabled === undefined || privilegeFilter.Enabled); })
                .map(function (privilege) {
                formattedPrivileges.push({
                    PrivilegeId: privilege.PrivilegeId,
                    PrivilegeName: privilege.PrivilegeName,
                    Enabled: privilege.Enabled
                });
            });
        }
        return formattedPrivileges;
    };
    /*
    get Privilges which are not part of Privilege Group
    */
    PrivilegeService.prototype.uniquePrivilege = function (privileges, privilegeGroups) {
        privileges = this.privilegeData(privileges);
        if (privilegeGroups.length) {
            privilegeGroups.map(function (privilegeGroup) {
                privilegeGroup.Privileges.map(function (groupPrivilege) {
                    privileges = privileges.filter(function (privilege) { return privilege.PrivilegeId !== groupPrivilege.PrivilegeId; });
                });
            });
        }
        return privileges;
    };
    PrivilegeService.ngInjectableDef = i0.defineInjectable({ factory: function PrivilegeService_Factory() { return new PrivilegeService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: PrivilegeService, providedIn: "root" });
    return PrivilegeService;
}());
export { PrivilegeService };
